import { render } from "./LanguageGlobe.vue?vue&type=template&id=b3fac7ee"
import script from "./LanguageGlobe.vue?vue&type=script&lang=js"
export * from "./LanguageGlobe.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__